import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.replace("https://github.com/zainalsaputra");
  }, []);

  return null;
}

export default App;
